<template>
  <div class="settlement">
    <el-form :model="settlementData" ref="settlementForm" label-width="100px">
      <el-row>
        <el-col :span="6">
          <el-form-item label="付款方式">
            <el-input v-model="settlementData.payTypeName" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对账规则">
            <el-input v-model="settlementData.reconciliateRule" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对账周期">
            <el-input v-model="settlementData.reconciliatePeriod" disabled></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item label="对账日期">
            <el-input v-model="settlementData.reconciliateDate" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item label="逾期账期">
            <el-input v-model="settlementData.overdueAccountPeriod" disabled></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>

<script>
  export default {
    name: 'settlementInfo',
    props: ['settlementInfo', 'turnType'],
    data() {
      return {
        settlementData: {
          payTypeName: '',
          reconciliateRule: '',
          reconciliatePeriod: '',
          reconciliateDate: '',
          overdueAccountPeriod: '',
        },
      };
    },
    created() {
      if (this.turnType === '3') {
        this.getSettlementInfo();
      }
    },
    watch: {
      settlementInfo(newVal) {
        if (newVal) {
          console.log(newVal.payTypeName, '??????');
          this.settlementInfo = Object.assign(this.settlementInfo, newVal, {
            payTypeName: newVal.payTypeName == 'null,null' ? '' : newVal.payTypeName,
          });

          this.getSettlementInfo();
        }
      },
    },
    methods: {
      getSettlementInfo() {
        Object.assign(this.settlementData, this.settlementInfo);
      },
    },
  };
</script>
